<template>
    <transition mode="out-in" name="fade">
        <div class="container-fluid touch-page" v-if="show">
            <div class="inline100">
                <h1>Competitions: {{name}}</h1>
                <div class="col-lg-4 box" v-for="type in types" v-if="type.count>0">
                    <h2>{{type.name}}</h2>
                    <transition-group name="slide-fade" mode="out-in">
                        <router-link :key="'competitionid'+index" v-for="(el,index) in cometitionsByType[type.id]"class="btn btn-competition" active-class="active" :to="'/competition/view/'+el.id">{{el.name}}</router-link>
                    </transition-group>
                </div>
            </div>
            <div class="buttons center">
                <router-link class="btn btn-big btn-back" active-class="active" to="/">Home Page</router-link>
            </div>
        </div>
        <div v-else>
            <div class="loader" id="loader-1"></div>
        </div>
    </transition>
</template>
<script>
    import axios from 'axios'
    export default{
        data(){
            return {
                name: null,
                cometitionsByType: null,
                types: null,
                show: false
            }
        },
        mounted(){
            axios.get('/ajax.php?q=getCompetitionsList')
                .then(res => {
                    console.log(res);
                    this.name = res.data.name;
                    this.types = res.data.types;
                    this.cometitionsByType = res.data.cometitionsByType;
                    this.show = true;
                })
                .catch(error => console.log(error))
        }
    }
</script>
<style scoped>
    .btn-big.btn-back{
        background: #337ab7;
    }
</style>


// WEBPACK FOOTER //
// src/components/Competitions/List.vue